export default __webpack_public_path__ + "static/media/homam.cd6c4a0a.png";